import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config, ApiVisa } from "../shared";
import { AppTenantDeletionEventHdrContainerModel } from "../../../../../models/aggregates/app-tenant-deletion/app-tenant-deletion-event-hdr-container.model";
import { Observable } from "rxjs";
import { ApiResponseModel } from '../shared/api-response.model';

@Injectable({
  providedIn: "root",
})
export class AppTenantDeletionEventHdrService extends BaseApiTemplateService<AppTenantDeletionEventHdrContainerModel> {
  constructor(http: HttpClient) {
    super();
    
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX +
      "applet/tenant-deletion-event-hdrs/" + 
      Core2Config.BACKOFFICE_EP_SUFFIX;
    
    this.endpoint_path =
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX +
      "applet/tenant-deletion-event-hdrs/" + 
      Core2Config.BACKOFFICE_EP_SUFFIX;
    
    this.httpClient = http;
  }

  public postTenantDeletionCleanup(
    tenant_hdr_guid: string,
    apiVisa: ApiVisa
  ): Observable<ApiResponseModel<any>> {

    let apiUrl = apiVisa.api_domain_url + 
        Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 
        "applet/tenant-deletion-event-hdrs/post-tenant-deletion-cleanup/" +
        tenant_hdr_guid;

    return this.httpClient.delete<ApiResponseModel<any>>(
        apiUrl,
        this.getHttpHeader(apiVisa)
    );
  }
}